import { useState, useEffect } from 'react';
import { API_BASE_URL } from '../config.js';
import { sourceParam } from '../constants/visitsSource.js';

/**
 * Hook personnalisé pour récupérer les données d'avancement annuel
 * Récupère les visites planifiées + count des visites effectuées depuis le début de l'année
 */
const useAnnualProgress = ({
  selectedProject,
  startDate,
  endDate,
  fetchWithAuth
}) => {
  const [annualProgressData, setAnnualProgressData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAnnualProgress = async () => {
      if (!selectedProject || !startDate || !endDate) {
        setAnnualProgressData(null);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const startDateStr = startDate.toISOString().split('T')[0];
        const endDateStr = endDate.toISOString().split('T')[0];

        const response = await fetchWithAuth(
          `${API_BASE_URL}/api/dwh/visits/${selectedProject.value}/annual-progress`
          + `?${sourceParam(selectedProject)}&startDate=${startDateStr}&endDate=${endDateStr}`
        );

        if (response.ok) {
          const data = await response.json();
          setAnnualProgressData(data);
        } else {
          console.error("Failed to fetch annual progress data");
          setError("Failed to fetch annual progress data");
          setAnnualProgressData(null);
        }
      } catch (error) {
        console.error("Error fetching annual progress:", error);
        setError(error.message);
        setAnnualProgressData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchAnnualProgress();
  }, [selectedProject, startDate, endDate, fetchWithAuth]);

  return {
    annualProgressData,
    loading,
    error
  };
};

export default useAnnualProgress;
